<template>
  <div
    class="tooltip-wrapper"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @click="onClick"
  >
    <slot />
    <transition name="tooltip">
      <div
        v-if="isVisible"
        :class="[
          'custom-tooltip',
          `custom-tooltip-${placement}`,
          `custom-tooltip-${variant}`,
          additionalClass
        ]"
      >
        {{ text }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: value => ['hover', 'click'].includes(value)
    },
    variant: {
      type: String,
      default: 'secondary',
      validator: value => [
        'primary', 'secondary', 'success',
        'danger', 'warning', 'info',
        'light', 'dark'
      ].includes(value)
    },
    additionalClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  methods: {
    onMouseEnter () {
      if (this.trigger === 'hover') {
        this.isVisible = true
      }
    },
    onMouseLeave () {
      if (this.trigger === 'hover') {
        this.isVisible = false
      }
    },
    onClick () {
      if (this.trigger === 'click') {
        this.isVisible = !this.isVisible
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$bg-color: rgba(0, 0, 0, 0.9);
.tooltip-wrapper {
  display: inline-block;
  position: relative;
  .custom-tooltip {
    position: absolute;
    background: $bg-color;
    color: #fff;
    padding: 12px;
    border-radius: 8px;
    @include font__paragraph-1--bold();
    z-index: 1000;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 200px;
    width: max-content;
    text-align: left;
    &:before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
    }
  }
  .custom-tooltip-top {
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    &:before {
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 8px 8px 0 8px;
      border-color: $bg-color transparent transparent transparent;
    }
  }
  .custom-tooltip-bottom {
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    &:before {
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      border-width: 0 8px 8px 8px;
      border-color: transparent transparent $bg-color transparent;
    }
  }
  .custom-tooltip-left {
    right: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
    &:before {
      top: 50%;
      right: -8px;
      transform: translateY(-50%);
      border-width: 8px 0 8px 8px;
      border-color: transparent transparent transparent $bg-color;
    }
  }
  .custom-tooltip-right {
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);
    &:before {
      top: 50%;
      left: -8px;
      transform: translateY(-50%);
      border-width: 8px 8px 8px 0;
      border-color: transparent $bg-color transparent transparent ;
    }
  }

}
</style>
